import React from "react";
import Portfolio from "../Components/portfolio/Portfolio";
import TopBar from "../Components/common/TopBar";
import Spacer from "../Components/common/Spacer";

function PortfolioPage() {
  return (
    <>
      <TopBar />
      <Spacer />
      <Portfolio />
    </>
  );
}

export default PortfolioPage;
